import { gql } from '@apollo/client';

export const RdProjectTpTicketsViewFragment = gql`
  fragment RdProjectTpTicketsView on RdProjectTpTicketsView {
    id
    rdProjectId
    rdTaxCreditContributorId
    contributorName
    identifier
    ticketUrl
    name
    description
    completedDatetime
    collectionName
    predictedEffortDays
    groupingTicketingProviderTicketId
    groupingTicketingProviderCollectionId
  }
`;
